// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__3x1WQ","inputSuccess":"FieldCurrencyInput_inputSuccess__TBuSb","inputError":"FieldCurrencyInput_inputError__1Cz7X"};